import { Component, Input, OnInit } from '@angular/core';
import { Color } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-chart-bar-vertical',
  templateUrl: './chart-bar-vertical.component.html',
  styleUrls: ['./chart-bar-vertical.component.scss'],
})
export class ChartBarVerticalComponent implements OnInit {
  @Input() isLoadingStats!: boolean;
  @Input() isLoadingStatsErrorOccured!: boolean;
  @Input() showYAxis!: boolean;
  @Input() showXAxis!: boolean;
  @Input() gradient!: boolean;
  @Input() results!: any[];
  @Input() colorScheme!: Color;
  @Input() view!: [number, number];
  @Input() title!: string;

  constructor() {}

  ngOnInit(): void {}
}
